"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const CompRegoFullButOpen_orangeIcon = createIcon({
  displayName: "CompRegoFullButOpen_orangeIcon",
  viewBox: "0 0 44 32.83",
  path: (
    <>
      <path
        d="M16.4,16.44c-2.25,0-4.18-.8-5.8-2.42-1.6-1.6-2.42-3.55-2.42-5.8s.8-4.18,2.42-5.8c1.6-1.6,3.55-2.42,5.8-2.42s4.18.8,5.8,2.42c1.62,1.62,2.42,3.55,2.42,5.8s-.8,4.18-2.42,5.8c-1.6,1.6-3.55,2.42-5.8,2.42ZM0,32.83v-5.74c0-1.17.31-2.23.9-3.2.59-.98,1.39-1.72,2.38-2.23,2.11-1.07,4.26-1.84,6.46-2.38,2.19-.53,4.41-.8,6.66-.8s4.47.27,6.66.8c2.19.53,4.34,1.33,6.46,2.38.98.51,1.78,1.25,2.38,2.23.59.98.9,2.05.9,3.2v5.74H0ZM4.1,28.73h24.59v-1.64c0-.37-.1-.72-.29-1.02-.18-.31-.43-.55-.74-.72-1.84-.92-3.71-1.62-5.59-2.07-1.89-.45-3.77-.7-5.7-.7s-3.81.23-5.7.7c-1.89.47-3.75,1.15-5.59,2.07-.31.16-.55.41-.74.72-.18.31-.29.66-.29,1.02v1.64h.04ZM16.4,12.34c1.13,0,2.09-.41,2.89-1.21.8-.8,1.21-1.76,1.21-2.89s-.41-2.09-1.21-2.89c-.8-.8-1.76-1.21-2.89-1.21s-2.09.41-2.89,1.21c-.8.8-1.21,1.76-1.21,2.89s.41,2.09,1.21,2.89c.8.8,1.76,1.21,2.89,1.21Z"
        fill="currentColor"
      />
      <path
        d="M43.37,8.1c-.43-.98-1.02-1.84-1.76-2.58-.72-.74-1.6-1.33-2.58-1.74-1.99-.86-4.39-.86-6.37,0-.98.43-1.86,1-2.6,1.74-.72.72-1.31,1.6-1.74,2.58-.43,1-.64,2.07-.64,3.2s.2,2.19.64,3.18c.43,1,1.02,1.86,1.74,2.6.74.74,1.62,1.31,2.6,1.74s2.05.64,3.18.64,2.21-.2,3.2-.64,1.86-1,2.58-1.74c.74-.74,1.33-1.6,1.76-2.6.41-.98.64-2.05.64-3.18s-.23-2.19-.64-3.2ZM40.17,7.69c.35.43.64.92.86,1.43.27.7.41,1.43.41,2.17,0,1.58-.53,2.89-1.62,3.98-1.09,1.09-2.4,1.64-4,1.64s-2.87-.53-3.98-1.64c-1.11-1.09-1.64-2.4-1.64-3.98s.53-2.89,1.64-3.98c.98-.98,2.11-1.52,3.46-1.62v6.82l4.86-4.84Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
    color: "orange.500",
  },
});

export default CompRegoFullButOpen_orangeIcon;
